import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { useSelector } from 'hooks/redux'
import { useMakeDispatchCallback } from 'hooks'
import { getIsEditing } from 'selectors/navigator'
import { setSelectedIdWithDrawer } from 'actions/navigator'
import strings from 'utils/strings'
import { Button, Paragraph } from 'components/patterns'
import { List, ListLabel, ListItem } from './NavList.style.js'

const missingData = <Paragraph>{strings.n_a_lowercase}</Paragraph>

const NavList = ({
  label,
  items,
  navProp,
  actionButton: { onClick, label: actionLabel },
}) => {
  const setSelectedIdCallback = useMakeDispatchCallback(setSelectedIdWithDrawer)

  const isEditing = useSelector(getIsEditing)

  const makeFunctionNodeSelectButton = (id, description) => (
    <ListItem key={`list-${description}-${id}`}>
      <Button link size="small" onClick={() => setSelectedIdCallback(id)}>
        {description}
      </Button>
    </ListItem>
  )

  const showNoneText =
    (label === strings.logic_sets || label === strings.timers) && isEmpty(items)

  return (
    <List>
      <ListLabel>{label}</ListLabel>
      {items &&
        items.map((item) =>
          makeFunctionNodeSelectButton(item[navProp], item.description)
        )}
      {onClick && isEditing && (
        <Button link size="small" onClick={onClick}>
          {`+ ${actionLabel}`}
        </Button>
      )}
      {showNoneText && <Paragraph>{strings.none}</Paragraph>}
      {isEditing && !items && !onClick && missingData}
      {!isEditing && (items.length === 0 || !items) && missingData}
    </List>
  )
}

NavList.propTypes = {
  label: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  navProp: PropTypes.string,
  actionButton: PropTypes.oneOfType([
    PropTypes.shape({
      onClick: PropTypes.func,
      label: PropTypes.string,
    }),
    PropTypes.bool,
  ]),
}

export default NavList
